<div class="statistics">
    <div class="table-statistics">
        <div class="header-title">
            Table View
        </div>

        <nz-table #basicTable [nzData]="tableData" class="table" [nzSize]="'small'" [nzShowPagination]="false">
          <thead>
            <tr>
              <th>Status</th>
              <th>Count</th>
              <th>Percentage</th>
              <th *ngIf="!isFromTask"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of basicTable.data">
              <td>{{ data.name }}</td>
              <td [ngStyle]="{'color': data.itemStyle ? data.itemStyle.color : 'black' }">{{ data.value }}</td>
              <td [ngStyle]="{'color': data.itemStyle ? data.itemStyle.color : 'black' }">{{ format(data.value) }}</td>
              <td class="remove-padding" *ngIf="!isFromTask">
                  <button nz-button (click)="detail(data)" class="text-btn-primary" [nzSize]="'small'">Detail</button>
              </td>
            </tr>
          </tbody>
        </nz-table>
    </div>

    <div class="chart-statistics">
        <div class="header-title">
            PIE View
        </div>

        <div echarts [options]="options" class="chart" (chartInit)="onChartInit($event)"></div>
    </div>
</div>


